import { render, staticRenderFns } from "./CustomizeMetalAX.vue?vue&type=template&id=02f6d599&scoped=true"
import script from "./CustomizeMetalAX.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAX.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAX.vue?vue&type=style&index=0&id=02f6d599&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f6d599",
  null
  
)

export default component.exports